import { enqueueSnackbar } from "notistack";
import i18n from "i18next";
import axios from "axios";
import { snackBarMessageWithSupportId } from "@/TelemetryInit";

export const onError = (error: any, _variables?: unknown, _context?: unknown): void => {
    if (axios.isCancel(error)) {
        return;
    }
    // avoid showing html error messages in snackbar, as they are not user-friendly
    if (error?.message?.toLowerCase()?.includes("<html")) {
        console.error(`${i18n.t('unexpected_error', { ns: 'errorMessages' })}: ${error?.message}`);
        return;
    }
    enqueueSnackbar(snackBarMessageWithSupportId(i18n.t(error?.message ?? 'unexpected_error', { ns: 'errorMessages' }), error), { variant: 'error' });
};
